import SearchTrainByNumber from './SearchTrainByNumber';

export default SearchTrainByNumber;
